import React from 'react';

interface StatsCardProps {
  count: any;
  label: string;
  icon: React.ReactNode;
  color?: string;
  trend?: string; // e.g., "↑ 12%" or "↑ 8%"
  trendPeriod?: string; // e.g., "VS. last 90 days"
}

export const StatsCard: React.FC<StatsCardProps> = ({
  count,
  label,
  icon,
  color = '#4FD1C5',
  trend,
  trendPeriod,
}) => {
  return (
    <div
      style={{
        padding: '20px',
        background: '#FFFFFF',
        borderRadius: '12px',
        border: '1px solid #E2E8F0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box',
      }}
    >
      {/* Top section: Count and Icon */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start' 
      }}>
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          alignItems: 'flex-start' 
        }}>
          <div
            style={{
              width: '4px',
              height: '48px',
              background: color,
              borderRadius: '2px',
              flexShrink: 0,
            }}
          ></div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div
              style={{ 
                fontWeight: 700, 
                fontSize: '32px', 
                lineHeight: '1',
                color: '#2D3748',
                fontFamily: 'Quicksand, sans-serif',
              }}
            >
              {count}
            </div>
            <div
              style={{ 
                fontWeight: 600, 
                color: '#718096', 
                fontSize: '14px',
                lineHeight: '1.2',
                fontFamily: 'Quicksand, sans-serif',
              }}
            >
              {label}
            </div>
          </div>
        </div>

        <div
          style={{
            width: '48px',
            height: '48px',
            border: '1px solid #E2E8F0',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
      </div>

      {/* Bottom section: Trend (if provided) */}
      {trend && (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '4px',
          fontSize: '12px',
          fontFamily: 'Quicksand, sans-serif',
        }}>
          <span style={{ 
            color: trend.startsWith('↑') ? '#48BB78' : '#F56565',
            fontWeight: 600,
          }}>
            {trend}
          </span>
          <span style={{ 
            color: '#A0AEC0',
            fontWeight: 500,
          }}>
            {trendPeriod}
          </span>
        </div>
      )}
    </div>
  );
};
